/**
 * BCO Theme Scripts
 */

// Nav scroll state
(function() {
  var nav = document.getElementById('nav');
  if (!nav) return;
  window.addEventListener('scroll', function() {
    nav.classList.toggle('scrolled', window.scrollY > 60);
  }, { passive: true });
})();

// Burger menu toggle
(function() {
  var burger = document.getElementById('nav-burger');
  var drawer = document.getElementById('nav-drawer');
  if (!burger || !drawer) return;
  burger.addEventListener('click', function() {
    var isOpen = drawer.classList.toggle('is-open');
    burger.classList.toggle('is-open', isOpen);
    burger.setAttribute('aria-expanded', isOpen);
    drawer.setAttribute('aria-hidden', !isOpen);
  });
  // Close drawer when a link inside it is clicked
  drawer.addEventListener('click', function(e) {
    if (e.target.tagName === 'A') {
      drawer.classList.remove('is-open');
      burger.classList.remove('is-open');
      burger.setAttribute('aria-expanded', 'false');
      drawer.setAttribute('aria-hidden', 'true');
    }
  });

  // Close drawer when screen grows back to desktop width
  window.addEventListener('resize', function() {
    if (window.innerWidth > 768) {
      drawer.classList.remove('is-open');
      burger.classList.remove('is-open');
      burger.setAttribute('aria-expanded', 'false');
      drawer.setAttribute('aria-hidden', 'true');
    }
  }, { passive: true });
})();

// Marquee: clone track for seamless loop if needed
(function() {
  var track = document.querySelector('.marquee-track');
  if (!track) return;
  // The marquee is already duplicated in the HTML for seamless animation
})();

// ─── BCO Warenkorb Geschenk: ein Probeset von zwei auswaehlen ─────────────
(function() {
  var BUSY = false;

  function updateUrl() {
    try { if (window.Theme && Theme.routes && Theme.routes.cart_update_url) return Theme.routes.cart_update_url; } catch (e) {}
    return '/cart/update.js';
  }

  function sectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function(c) {
      if (c.dataset.sectionId && ids.indexOf(c.dataset.sectionId) === -1) ids.push(c.dataset.sectionId);
    });
    return ids;
  }

  // Setzt Mengen ueber die Varianten ID und laesst das Theme den Warenkorb neu rendern.
  function applyUpdates(updates) {
    var body = {
      updates: updates,
      sections: sectionIds(),
      sections_url: window.location.pathname
    };
    return fetch(updateUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        var evt = new Event('cart:update', { bubbles: true });
        evt.detail = {
          resource: cart,
          sourceId: 'bco-gift-chooser',
          data: { source: 'bco-gift-chooser', itemCount: cart.item_count, sections: cart.sections }
        };
        document.dispatchEvent(evt);
        return cart;
      });
  }

  // Klick auf eine Geschenk Kachel (Event Delegation, ueberlebt jedes Neu-Rendern).
  document.addEventListener('click', function(e) {
    var opt = e.target.closest ? e.target.closest('.bco-gift__option') : null;
    if (!opt) return;
    e.preventDefault();

    var chooser = opt.closest('#bco-gift');
    if (!chooser || BUSY) return;

    var chosen = parseInt(opt.getAttribute('data-variant-id'), 10);
    var g1 = parseInt(chooser.getAttribute('data-gift-1'), 10);
    var g2 = parseInt(chooser.getAttribute('data-gift-2'), 10);
    var alreadySelected = opt.getAttribute('aria-pressed') === 'true';

    var updates = {};
    if (alreadySelected) {
      // nochmal auf das gewaehlte tippen entfernt das Geschenk
      updates[chosen] = 0;
    } else {
      updates[chosen] = 1;
      if (chosen === g1 && g2) updates[g2] = 0;
      if (chosen === g2 && g1) updates[g1] = 0;
    }

    BUSY = true;
    chooser.setAttribute('data-busy', '1');
    chooser.setAttribute('aria-busy', 'true');
    applyUpdates(updates)
      .catch(function(err) { console.error('[bco-gift]', err); })
      .finally(function() {
        BUSY = false;
        var c = document.getElementById('bco-gift');
        if (c) { c.removeAttribute('data-busy'); c.removeAttribute('aria-busy'); }
      });
  });

})();
